var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CheckboxGroup',{attrs:{"value":_vm.value,"options":_vm.statuses,"disabled":_vm.disabled,"show-confetti":_vm.showConfetti},on:{"input":_vm.input,"complete":_vm.completeAnimation}})
}
var staticRenderFns = []

export { render, staticRenderFns }